<template>
    <div class="ValetOrder">
        <a-card title="代客下单" :border="false">
            <div class="BuyUser">
                <span>*</span>
                <label>购买用户：</label>
            </div>
            <div class="changeUser">
                <a-button type="primary" class="cancel" @click="visible2 = true" ghost>选择会员</a-button>
            </div>
            <div class="table">
                <a-table :columns="columns" :data-source="dataSource" :pagination="false">
                    <template slot="address" slot-scope="text, record">
                        <a v-if="JSON.stringify(record.address) == '{}'" @click="Addsite(record.user_id)">添加地址</a>
                        <div class="addressInfo" v-else>
                            <div>
                                <span>{{record.address.name}}</span>
                                <span style="padding-left:5px;">{{record.address.mobile}}</span>
                            </div>
                            <p>{{shengName}}{{shiName}}{{xianName}}{{record.address.address}}
                                <!-- {{record.address.address}} -->
                            </p>
                        </div>
                    </template>
                </a-table>
            </div>

            <div class="BuyUser">
                <span>*</span>
                <label>购买商品：</label>
            </div>
            <div class="changeUser">
                <a-button type="primary" class="cancel" @click="visible3 = true" ghost>添加商品</a-button>
            </div>
            <div class="table">
                <a-table :columns="ChangecolumnsPro2" :data-source="ChangedataSourcePro2" :pagination="false">
                    <template slot="proName" slot-scope="text, record, index">
                        <div class="Info">
                            <img :src="record.img" width="40" height="40" alt="">
                            <span>{{record.product_title}}</span>
                        </div>
                    </template>
                    <template slot="num" slot-scope="text, record, index">
                        <!-- <a-input-number id="inputNumber" v-model="record.nums" :min="1" /> -->
                        <span>{{record.nums}}</span>
                    </template>
                    <template slot="action" slot-scope="text, record, index">
                        <a @click="ChangeProdel(index)">删除</a>
                    </template>
                </a-table>
            </div>
            <div class="BottomPrice">
                <div class="Price">
                    <label for="">商品总价：</label>
                    <span>¥{{Info.gz_price || 0}}</span>
                </div>
                <div class="Price">
                    <label for="">会员折扣：</label>
                    <span>-¥{{Info.grade_discount || 0}}</span>
                </div>
                <div class="Price">
                    <label for="">立减：</label>
                    <a-input v-model="wipe_off" @blur="wipeBlur" placeholder=""></a-input>
                </div>
                <div class="Price Total">
                    <label for="">合计支付：</label>
                    <span>¥{{Info.z_price || 0}}</span>
                </div>
            </div>

        </a-card>
        <div class="FixedRight">
            <a-button type="primary" @click="cancel" class="cancel" ghost>
                取消
            </a-button>
            <a-button @click="payOrder" type="primary">
                确认下单
            </a-button>
        </div>

        <a-modal v-model="visible" title="添加地址" @ok="handleOk">
            <a-form :form="form" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
                <a-form-item label="收货人">
                    <a-input v-decorator="['name',
                        { rules: [{ required: true, message: '请输入收货人姓名' }] },
                        ]" placeholder="请输入收货人姓名" />
                </a-form-item>
                <a-form-item label="联系电话">
                    <a-input v-decorator="['mobile',
                        { rules: [{ required: true, message: '请输入收货人电话' }] },
                        ]" placeholder="请输入收货人电话" />
                </a-form-item>

                <a-form-item label="选择地区" :required="true" class="ChangeAddress">
                    <a-form-item>
                        <a-select @change="ChangeSheng" v-decorator="['sheng',
                            {rules: [{ required: true, message: '请选择省' }]}]" placeholder="省" style="width:110px;">
                            <a-select-option v-for="(item,index) in sheng" :key="item.GroupID" :value="item.GroupID">
                                {{item.G_CName}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select @change="ChangeShi" v-decorator="['shi',
                            {rules: [{ required: true, message: '请选择市' }]}]" placeholder="市" style="width:110px;">
                            <a-select-option v-for="(item,index) in shi" :key="item.GroupID" :value="item.GroupID">
                                {{item.G_CName}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                    <a-form-item>
                        <a-select @change="Changexian" v-decorator="['xian',
                            {rules: [{ required: true, message: '请选择县' }]}]" placeholder="县" style="width:110px;">
                            <a-select-option v-for="(item,index) in xian" :key="item.GroupID" :value="item.GroupID">
                                {{item.G_CName}}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-form-item>
                <a-form-item label="详细地址">
                    <a-input v-decorator="['address',
                        { rules: [{ required: true, message: '请输入详细地址' }] },
                        ]" placeholder="请输入详细地址" />
                </a-form-item>
            </a-form>
        </a-modal>
        <a-modal width="920px" v-model="visible2" @ok="handleOk2" title="选择会员">
            <div>
                <a-input v-model="userID" placeholder="请输入手机号" style="width:280px;margin-right:8px;">
                </a-input>
                <a-button class="Btn" @click="Reset" style="margin-right:8px;">重置</a-button>
                <a-button class="Btn2" @click="getProList" type="primary">查询</a-button>
            </div>
            <div class="table">
                <a-table :columns="columnsUser" :pagination="false" :data-source="dataSourceUser" @change="UserChange"
                    :row-selection="{ selectedRowKeys: selectedRowKeys2, onChange: onSelectChange2 }">

                </a-table>
            </div>
        </a-modal>

        <a-modal width="920px" v-model="visible3" @ok="handleOk3" title="添加商品">
            <a-radio-group class="radioGroup" v-model="radioValue" button-style="solid">
                <a-radio-button value="0">
                    查询商品
                </a-radio-button>
                <a-radio-button value="1">
                    已选商品
                </a-radio-button>
            </a-radio-group>
            <div v-show="radioValue == 0">
                <div class="Search">
                    <a-cascader :options="options" :load-data="loadData" placeholder="请输入商品分类" change-on-select
                        style="margin-right:8px;" @change="onChange" v-model="ProClass" :field-names="{
                            label:'pname',
                            value:'cid',
                            children:'children'
                        }" />
                    <a-select v-model="ProBrand" placeholder="请输入商品品牌" style="width:200px;margin-right:8px;">
                        <a-select-option v-for="(item,index) in ProBrandList" :key="item.brand_id"
                            :value="item.brand_id">
                            {{item.brand_name}}
                        </a-select-option>
                    </a-select>
                    <a-input v-model="ProName" placeholder="请输入商品名称" style="width:240px;margin-right:8px;"></a-input>
                    <a-button class="Btn" @click="Reset" style="margin-right:8px;">重置</a-button>
                    <a-button class="Btn2" @click="getGoods" type="primary">查询</a-button>
                </div>
                <!-- @change="handleTableChange" :pagination="pagination" -->
                <div class="table" style="margin-bottom:0;">
                    <a-table :columns="columnsPro" :data-source="dataSourcePro" :scroll="{ y: 300 }"
                        :rowKey="(record,index)=>{return record.id}" :pagination="pagination"
                        :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }">
                        <template slot="proName" slot-scope="text, record, index">
                            <div class="Info">
                                <img :src="record.img" width="40" height="40" alt="">
                                <span>{{record.product_title}}</span>
                            </div>
                        </template>
                    </a-table>
                </div>
            </div>

            <div class="table" v-show="radioValue == 1">
                <a-table :columns="ChangecolumnsPro" :scroll="{ y: 300 }" :data-source="ChangedataSourcePro"
                    :pagination="false">
                    <template slot="proName" slot-scope="text, record, index">
                        <div class="Info">
                            <img :src="record.img" width="40" height="40" alt="">
                            <span>{{record.product_title}}</span>
                        </div>
                    </template>
                    <template slot="num" slot-scope="text, record, index">
                        <a-input-number id="inputNumber" :default-value="record.nums"
                            @change="inputNumber($event,index,record.num)" :min="1" :max="Number(record.num)" />
                        <!-- <a-input v-model="record.nums" type="number"></a-input> -->
                    </template>
                </a-table>
            </div>
        </a-modal>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                columns: [],
                columnsPro: [],
                ChangecolumnsPro: [],
                ChangecolumnsPro2: [],
                columnsUser: [],
                dataSource: [],
                dataSourcePro: [],
                ChangedataSourcePro: [],
                ChangedataSourcePro2: [],
                dataSourceUser: [],
                selectedRowKeys: [],
                selectedRowKeys2: [],
                radioValue: '0',
                options: [],
                ProBrandList: [],
                ProClass: undefined,
                ProBrand: undefined,
                ProName: undefined,
                visible: false,
                visible2: false,
                visible3: false,
                level: undefined,
                userID: undefined,
                form: this.$form.createForm(this, {
                    name: 'coordinated'
                }),
                sheng: [],
                shengName: '',
                shi: [],
                shiName: '',
                xian: [],
                xianName: '',
                addressInfo: {},
                pagination: {
                    total: 0,
                    pageSize: 10, //每页中显示10条数据
                    // showSizeChanger: true,
                    pageSizeOptions: ["10", "20", "50", "100"], //每页中显示的数据
                    showTotal: total => `共有 ${total} 条数据`, //分页中显示总的数据
                },
                page: 1,
                wipe_off: 0,
                Info: {},
                selectionRowsPlus: []
            }
        },
        mounted() {
            this.columns = [{
                    title: "会员ID",
                    key: "user_id",
                    dataIndex: "user_id",
                    width: 100,
                    align: 'center'
                },
                {
                    title: "会员名称",
                    key: "user_name",
                    dataIndex: "user_name",
                    width: 100,
                    align: 'center'
                },
                {
                    title: "会员等级",
                    key: "grade_name",
                    dataIndex: "grade_name",
                    width: 100,
                    align: 'center'
                },
                {
                    title: "手机号码",
                    key: "mobile",
                    dataIndex: "mobile",
                    width: 100,
                    align: 'center'
                },
                {
                    title: "余额",
                    key: "money",
                    dataIndex: "money",
                    width: 100,
                    align: 'center'
                },
                {
                    title: "收货地址",
                    key: "address",
                    dataIndex: "address",
                    scopedSlots: {
                        customRender: "address"
                    },
                    width: 150,
                    align: 'center'
                },
            ]
            this.columnsPro = [{
                    title: "商品名称",
                    key: "proName",
                    dataIndex: "proName",
                    width: 100,
                    scopedSlots: {
                        customRender: "proName"
                    },
                },
                {
                    title: "规格",
                    key: "size",
                    dataIndex: "size",
                    width: 100,
                },
                {
                    title: "价格",
                    key: "price",
                    dataIndex: "price",
                    width: 100,
                },
                {
                    title: "库存",
                    key: "num",
                    dataIndex: "num",
                    width: 100,
                },
            ]
            this.ChangecolumnsPro = [{
                    title: "商品名称",
                    key: "proName",
                    dataIndex: "proName",
                    width: 200,
                    scopedSlots: {
                        customRender: "proName"
                    },
                },

                {
                    title: "规格",
                    key: "size",
                    dataIndex: "size",
                    width: 100,
                },
                {
                    title: "售价",
                    key: "price",
                    dataIndex: "price",
                    width: 100,
                },
                {
                    title: "购买数量",
                    key: "num",
                    dataIndex: "num",
                    width: 100,
                    scopedSlots: {
                        customRender: "num"
                    },
                },
            ]
            this.ChangecolumnsPro2 = [{
                    title: "商品名称",
                    key: "proName",
                    dataIndex: "proName",
                    width: 200,
                    scopedSlots: {
                        customRender: "proName"
                    },
                },
                {
                    title: "商品编号",
                    key: "id",
                    dataIndex: "id",
                    width: 70,
                },
                {
                    title: "规格",
                    key: "size",
                    dataIndex: "size",
                    width: 100,
                },
                {
                    title: "售价",
                    key: "price",
                    dataIndex: "price",
                    width: 100,
                },
                {
                    title: "购买数量",
                    key: "num",
                    dataIndex: "num",
                    width: 100,
                    scopedSlots: {
                        customRender: "num"
                    },
                },
                {
                    title: "操作",
                    key: "action",
                    dataIndex: "action",
                    width: 100,
                    scopedSlots: {
                        customRender: "action"
                    },
                },
            ]
            this.columnsUser = [{
                    title: "会员ID",
                    key: "user_id",
                    dataIndex: "user_id",
                    width: 100,
                },
                {
                    title: "会员名称",
                    key: "user_name",
                    dataIndex: "user_name",
                    width: 100,
                },
                {
                    title: "手机号",
                    key: "mobile",
                    dataIndex: "mobile",
                    width: 100,
                },
                {
                    title: "会员等级",
                    key: "grade_name",
                    dataIndex: "grade_name",
                    width: 100,
                },
                {
                    title: "余额",
                    key: "money",
                    dataIndex: "money",
                    width: 100,
                },
            ]
            this.getSheng()
            this.getClass()
            // this.getBrand()
            this.getGoods()
            // this.$warning({
            //     title: '下单失败',
            //     content: '余额不足，扣款不成功',
            // });
        },
        methods: {
            onSelect(record, selected) {
                selected
                    ?
                    this.selectionRowsPlus.push(record) :
                    this.selectionRowsPlus.splice(
                        this.selectionRowsPlus.findIndex(x => x.id === record.id),
                        1
                    )
                console.log(this.selectionRowsPlus);
            },
            onSelectAll(selected, selectedRows, changeRows) {
                this.selectionRowsPlus = selected ?
                    this.selectionRowsPlus.concat(changeRows) :
                    this.selectionRowsPlus.filter(x => !changeRows.find(i => i.id === x.id))
            },
            inputNumber(value, index, num) {
                if (value > num) {
                    this.$message.error('库存不足！')
                    return
                }
                this.$nextTick(() => {
                    this.ChangedataSourcePro[index].nums = value
                    this.ChangedataSourcePro = [...this.ChangedataSourcePro]
                })
            },
            handleOk() {
                this.form.validateFields((err, values) => {
                    if (!err) {
                        this.addressInfo = values
                        this.dataSource[0].address = this.addressInfo
                        this.visible = false
                    }
                });
            },
            handleOk2() {
                if (this.selectedRowKeys2.length == 0) {
                    this.$message.error('请选择会员！')
                    return
                }
                this.dataSource = []
                this.dataSource.push(this.dataSourceUser[this.selectedRowKeys2[0]])
                this.dataSource[0].address = {}
                this.visible2 = false
                this.SetOrder()
            },
            handleOk3() {
                console.log(this.ChangedataSourcePro);
                this.visible3 = false
                this.ChangedataSourcePro2 = this.ChangedataSourcePro
                this.SetOrder()
            },
            wipeBlur(e) {
                this.SetOrder()
            },
            SetOrder() {
                let products = []
                if (this.ChangedataSourcePro.length > 0) {
                    this.ChangedataSourcePro.filter(item => {
                        item.nums = item.nums
                        products.push({
                            id: item.id,
                            pid: item.pid,
                            num: item.nums
                        })
                    })
                }
                let data = {
                    uid: this.dataSource.length > 0 ? this.dataSource[0].user_id : '',
                    products: products,
                    wipe_off: this.wipe_off,
                    //收货信息
                    mobile: this.addressInfo.mobile,
                    name: this.addressInfo.name,
                    sheng: this.addressInfo.sheng,
                    shi: this.addressInfo.shi,
                    xian: this.addressInfo.xian,
                    address: this.addressInfo.address
                }
                let url = '?module=pc_api&action=order&m=Settlement'
                this.$request.post(url, data).then(res => {
                    if (res.code == 200) {
                        this.Info = res.data
                        if (Object.values(res.data.address_arr).length > 0) {
                            this.shengName = res.data.address_arr.sheng
                            this.shiName = res.data.address_arr.shi
                            this.xianName = res.data.address_arr.xian
                            this.addressInfo = {
                                mobile: res.data.address_arr.mobile,
                                name: res.data.address_arr.name,
                                address: res.data.address_arr.address,
                            }
                            this.dataSource[0].address = this.addressInfo
                        }
                    }
                })
            },
            payOrder() {
                let products = []
                if (this.ChangedataSourcePro.length == 0) {
                    this.$message.error('请选择商品！')
                    return
                }
                if (this.dataSource.length == 0) {
                    this.$message.error('请选择会员！')
                    return
                }

                if (JSON.stringify(this.addressInfo) == '{}') {
                    this.$message.error('请添加收货地址！')
                    return
                }
                this.ChangedataSourcePro.filter(item => {
                    products.push({
                        id: item.id,
                        pid: item.pid,
                        num: item.nums
                    })
                })
                let data = {
                    uid: this.dataSource[0].user_id,
                    products: products,
                    wipe_off: this.wipe_off,
                    //收货信息
                    mobile: this.addressInfo.mobile,
                    name: this.addressInfo.name,
                    sheng: this.shengName,
                    shi: this.shiName,
                    xian: this.xianName,
                    address: this.addressInfo.address,
                    pay: 'wallet_pay'
                }
                let url = '?module=pc_api&action=order&m=payment'
                this.$request.post(url, data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.message)
                        setTimeout(() => {
                            this.$router.go(-1);
                        }, 1000)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            },
            Addsite(id) {
                this.visible = true
            },
            onChange(value) {
                if (value.length == 0) {
                    this.ProBrandList = []
                }
                console.log(value);
            },
            loadData(selectedOptions) {
                const targetOption = selectedOptions[selectedOptions.length - 1];
                targetOption.loading = true;
                // load options lazily

                let url = '?module=pc_api&action=order&m=getClass'
                let data = {
                    sid: targetOption.cid
                }
                this.$request.post(url, data).then(res => {
                    targetOption.loading = false;
                    if (res.length != 0) {
                        res.filter(item => {
                            item.isLeaf = false
                        })
                    }
                    targetOption.children = [...res]
                    this.options = [...this.options]
                })

                this.getBrand(targetOption.cid)
            },
            getClass() {
                let url = '?module=pc_api&action=order&m=getClass'
                let data = {
                    sid: this.ProClass
                }
                this.$request.post(url, data).then(res => {
                    this.options = res
                    this.options.filter(item => {
                        item.isLeaf = false
                    })
                })
            },
            getBrand(cid) {
                let url = '?module=pc_api&action=order&m=getBrand'
                let data = {
                    cid: cid
                }
                this.ProBrandList = []
                this.ProBrand = undefined
                this.$request.post(url, data).then(res => {
                    this.ProBrandList = res
                })
            },
            getGoods() {
                let url = '?module=pc_api&action=order&m=getGoods'
                let data = {
                    c_id: this.ProClass ? this.ProClass[this.ProClass.length - 1] : '',
                    b_id: this.ProBrand,
                    name: this.ProName,
                    pagesize: this.pagination.pageSize,
                    page: this.page
                }
                this.$request.post(url, data).then(res => {
                    if (res.code == 200) {
                        this.dataSourcePro = res.data.list
                        this.dataSourcePro.filter(item => {
                            item.nums = 1
                        })
                        //this.pagination.total = Number(res.data.total)
                        //this.selectedRowKeys = []
                        // if (this.selectionRowsPlus.length > 0) {
                        //     this.dataSourcePro.filter(item => {
                        //         var indexs = this.selectionRowsPlus.findIndex(items => {
                        //             return items.id == item.id
                        //         })
                        //         console.log(indexs);
                        //         if (indexs != -1) {
                        //             this.selectedRowKeys.push(indexs)
                        //             console.log(this.selectedRowKeys);
                        //             return
                        //         }
                        //         this.selectedRowKeys = []
                        //     })
                        // } else {
                        //     this.selectedRowKeys = []
                        // }
                    }
                })
            },
            handleTableChange(e) {
                this.page = e.current
                this.pagination.pageSize = e.pageSize
                this.getGoods()
            },
            getSheng() {
                let url = '?module=pc_api&action=Mch&app=mch_address'
                let data = {}
                this.$request.post(url, data).then(res => {
                    if (res.code == 200) {
                        this.sheng = res.data
                    }
                })
            },
            getXian() {

            },
            ChangeSheng(e) {
                let url = '?module=pc_api&action=Mch&app=mch_address'
                let data = {
                    GroupID: e
                }
                let objName = this.sheng.find(item => {
                    return item.GroupID == e
                })
                this.shengName = objName.G_CName
                debugger
                this.form.setFieldsValue({
                    shi: undefined,
                    xian: undefined
                })
                this.$request.post(url, data).then(res => {
                    if (res.code == 200) {
                        this.shi = res.data
                    }
                })
            },
            ChangeShi(e) {
                let url = '?module=pc_api&action=Mch&app=mch_address'
                let data = {
                    GroupID: e
                }
                let objName = this.shi.find(item => {
                    return item.GroupID == e
                })
                this.shiName = objName.G_CName
                this.form.setFieldsValue({
                    xian: undefined
                })
                this.$request.post(url, data).then(res => {
                    if (res.code == 200) {
                        this.xian = res.data
                    }
                })
            },
            Changexian(e) {
                let objName = this.xian.find(item => {
                    return item.GroupID == e
                })
                this.xianName = objName.G_CName
            },
            getProList() {
                let data = {
                    mobile: this.userID
                }
                let url = '?module=pc_api&action=order&m=getUser'
                this.$request.post(url, data).then(res => {
                    if (res.code == 200) {
                        this.dataSourceUser = res.data.list
                    }
                })
            },
            ChangeProdel(index) {
                this.ChangedataSourcePro.splice(index, 1)
                this.selectedRowKeys.splice(index, 1)
                this.SetOrder()
            },
            Reset() {
                this.ProClass = undefined
                this.ProBrand = undefined
                this.ProName = undefined
                this.userID = undefined
                this.ProBrandList = []
            },
            UserChange(e) {
                console.log(e);
            },
            onSelectChange(e) {
                console.log(e);
                this.selectedRowKeys = e
                this.ChangedataSourcePro = []
                if (e.length > 0) {
                    e.filter(item => {
                        var indexs = this.dataSourcePro.find(items => {
                            return item === items.id
                        })
                        this.ChangedataSourcePro.push(indexs)
                    })

                    // this.dataSourcePro.filter(item => {
                    //     var indexs = e.find(items => {
                    //         return item.id === items
                    //     })
                    //     console.log(indexs);
                    //     // if (indexs != -1) {
                    //     //     this.ChangedataSourcePro.push(this.dataSourcePro[indexs])
                    //     // }

                    // })
                } else {
                    this.ChangedataSourcePro = []
                }
            },
            onSelectChange2(e) {
                console.log(e);
                this.selectedRowKeys2 = e
            },
            cancel() {
                this.$router.go(-1);
            }
        }
    }
</script>

<style lang="less" scoped>
    .ValetOrder {
        width: 100%;
        height: 100%;
        position: relative;
    }

    .flex {
        display: flex;
        align-items: center;
    }

    .BuyUser {
        display: flex;
        align-items: center;

        span {
            color: #FF3333;
            font-size: 14px;
        }

        label {
            font-size: 14px;
            font-weight: 400;
            color: #323544;
        }
    }

    .changeUser {

        margin-top: 16px;

        button {
            width: 88px;
            height: 32px;
        }
    }

    .Info {
        display: flex;
        align-items: center;

        span {
            width: 150px;
            display: inline-block;
            white-space: normal;
            text-align: left;
            padding-left: 10px;
        }
    }

    .table {
        margin-top: 14px;
        margin-bottom: 40px;
    }

    .radioGroup {
        margin-top: 14px;
    }

    .Search {
        display: flex;
        align-items: center;
        margin-top: 14px;
    }

    .Btn {
        border: 1px solid #828B97;
        color: #323544;
    }

    .Btn2 {
        background: #323544;
        color: #FFFFFF;
        border-color: #323544;
    }

    .Btn2:hover {
        background: #323544;
        border-color: #323544;
        opacity: 0.7;
    }

    .BottomPrice {
        display: flex;
        align-items: flex-end;
        flex-direction: column;

        .Price {
            margin-bottom: 18px;

            label {
                width: 120px;
                display: inline-block;
            }

            span {
                width: 100px;
                display: inline-block;
                text-align: right;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #414658;
            }

            input {
                width: 100px;
                text-align: right;
            }
        }

        .Total {
            label {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #414658;
            }

            span {
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: bold;
                color: #FF5555;
            }
        }
    }

    .FixedRight {
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        height: 72px;
        padding: 20px;
        box-sizing: border-box;
        border-top: 1px solid #E9ECEF;
        text-align: right;
        z-index: 999;
        background: #ffffff;

        .cancel {
            margin-right: 10px;
        }

        button {
            width: 100px;
            height: 32px;
        }
    }

    .addressInfo {
        display: flex;
        flex-direction: column;

        div {
            text-align: left;
        }

        p,
        span {
            font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #1E202C;
            text-align: left;
        }
    }

    .ChangeAddress /deep/.ant-form-item-children {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    /deep/ .ant-radio-button-wrapper-checked {
        color: #ffffff !important;

    }

    /deep/ .ant-card {
        overflow: auto;
        padding-bottom: 80px;
    }

    /deep/ .ant-card-body {
        padding: 24px !important;
    }
</style>